// extracted by mini-css-extract-plugin
module.exports = {"active":"OjJZafxBo0bvSmLslTXf","secondaryNav":"MvwzYeXa5P5rY0ZadIf8"};